module.exports = __webpack_public_path__ + "img/fedex_logo.7fe9c1c6.svg";